import { call, put, takeEvery } from "redux-saga/effects"

import { 
  GET_CONVERSION_LOG_STICKY_COLUMNS, 
  UPDATE_CONVERSION_LOG_STICKY_COLUMNS 
} from "./actionTypes"

import { 
  getConversionLogStickyColumnsError, 
  getConversionLogStickyColumnsSuccess, 
  updateConversionLogStickyColumnsError, 
  updateConversionLogStickyColumnsSuccess 
} from "./actions"

import { genericGetRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"

function* ongetConversionLogStickyColumns() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_col_pref_conversion_logs`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    )
    yield put(getConversionLogStickyColumnsSuccess(response))
  } catch (error) {
    yield put(getConversionLogStickyColumnsError(error))
  }
}

function* onupdateConversionLogStickyColumns(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_col_pref_conversion_logs/${action?.payload?.user_col_pref_conversion_log?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateConversionLogStickyColumnsSuccess(response))
  } catch (error) {
    yield put(updateConversionLogStickyColumnsError(error))
  }
}

function* userConversionLogColumnPreferenceSaga() {
  yield takeEvery(GET_CONVERSION_LOG_STICKY_COLUMNS, ongetConversionLogStickyColumns)
  yield takeEvery(UPDATE_CONVERSION_LOG_STICKY_COLUMNS, onupdateConversionLogStickyColumns)
}

export default userConversionLogColumnPreferenceSaga;
